import { render } from "./Polls.vue?vue&type=template&id=2fe2dc97&scoped=true"
import script from "./Polls.vue?vue&type=script&lang=js"
export * from "./Polls.vue?vue&type=script&lang=js"

import "./Polls.vue?vue&type=style&index=0&id=2fe2dc97&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe2dc97"]])

export default __exports__